var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#362416",
    d: "M403.8,71.8c-2.1-0.6-4.5-1.2-7.2-1.7c-4.1-0.8-8.7-1.5-13.5-2c-0.9-0.1-1.8-0.2-2.7-0.3 c-8.8-0.8-18.2-1.1-27.1-0.7c-0.8,0-1.5,0.1-2.3,0.1c-5.5,0.3-10.7,0.9-15.4,1.8c-0.4,0.1-0.8,0.2-1.2,0.2 c-1.1,0.2-2.3,0.5-3.4,0.7c-9.6,2-19.2,4.8-27.5,10c-0.5,0.3-1,0.7-1.6,1c-2.7,1.9-5.5,3.8-7.6,6.2c36.5-20.1,81.8-21.4,120.2-7.3 C412.5,75.5,408.9,73.3,403.8,71.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.2,99.5c1,3.2,3.2,5.8,5.7,7.5c5.9-3.5,12.2-6.5,18.5-8.8s12.9-4.1,19.5-5.4c5-1,10-1.6,15.1-1.9s10.2-0.4,15.3-0.1 c14.1,0.7,27.7,4,40.3,9.6c0.6-0.2,1.2-0.5,1.8-0.7C373.1,78.7,325.2,75.1,291.2,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,33.1c-2.4-0.6-5.1-0.7-8.1-0.2c-0.2-0.3-0.3-0.6-0.5-0.8c-1,9.6-3.6,25-10.9,35.8c0.9,0.1,1.8,0.2,2.7,0.3 C391.4,61.6,399.8,45.4,399.8,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,24.3c-2.9,0.9-5.6,2.4-8.1,4.5c-0.2,12.9-2.3,27.3-6.3,38.5c0.8,0,1.5-0.1,2.3-0.1 C363,56.4,365.9,35.8,365.4,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,70.1c1.1-0.2,2.3-0.5,3.4-0.7c-9.2-9.7-16.5-22-17.2-34.6c0,0.1,0,0.1,0,0.2c-2.6-0.1-5.2,0.1-7.7,0.6 C310.3,50.9,320.9,64,331,70.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.6,42.3c-2.5-4.3-6.4-7.9-11.8-9.2c0,12.2-8.4,28.5-16.7,35c4.8,0.5,9.4,1.2,13.5,2c2.7,0.5,5.1,1,7.2,1.7 c2.1-1.9,5.1-5.5,6.2-7C413.7,59.9,415.7,49.3,411.6,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,24.3c0.6,11.5-2.4,32.1-12.1,42.9c8.9-0.4,18.3-0.1,27.1,0.7c7.3-10.8,9.8-26.2,10.9-35.8 C386.8,25,375.6,21,365.4,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,29c-7.8-11.8-38.1-8.4-39.8,5.7c0.7,12.6,8,24.9,17.2,34.6c0.4-0.1,0.8-0.2,1.2-0.2c4.7-0.9,9.9-1.5,15.4-1.8 c4-11.2,6.1-25.6,6.3-38.5C357.2,28.9,357.1,28.9,357.1,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,35.6c-3.8,0.8-7.4,2.4-10.4,5c-7.1,6.2-9.2,14-7.6,22.6c1.7,8.9,5.4,12,12,16.8c8.3-5.2,17.9-7.9,27.5-10 C320.9,64,310.3,50.9,309.4,35.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1046,
    d: "M438.7,182L438.7,182C438.7,182.1,438.7,182.1,438.7,182 C438.8,182,438.7,181.9,438.7,182z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M465.7,177.7c0-1.8,0-3.6-0.2-5.3l0,0C465.7,174.2,465.8,175.9,465.7,177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M430.6,115.4c-0.9-0.7-1.9-1.5-2.8-2.2C428.7,114,429.7,114.7,430.6,115.4L430.6,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M424.9,111.2c0.9,0.6,1.7,1.2,2.5,1.8C426.6,112.4,425.8,111.8,424.9,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M465.7,177.7c0,0.1,0,0.3,0,0.4C465.7,178,465.7,177.8,465.7,177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M424.4,110.8c0.2,0.1,0.4,0.2,0.5,0.4C424.8,111.1,424.6,110.9,424.4,110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352416",
    d: "M457,146.7c-6.6-12.1-15.7-22.7-26.4-31.3l0,0c-0.9-0.7-1.9-1.5-2.8-2.2c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.8-0.6-1.7-1.2-2.5-1.8c-0.2-0.1-0.4-0.2-0.5-0.4c-5.9-4.1-12.2-7.6-18.8-10.5c-12.5-5.5-26.2-8.8-40.3-9.6 c-5.1-0.3-10.2-0.3-15.3,0.1c-5.1,0.3-10.1,1-15.1,1.9c-6.7,1.3-13.2,3.1-19.5,5.4c-6.4,2.3-12.6,5.3-18.5,8.8 c-22.8,13.5-41.7,35-48.6,59.5c-1.8,10.6-1.1,22,6.4,27.1c3.8,2.6,9.3,3.9,13.7,2.5c1.5-1.7,2.4-3.8,2.6-6.2 c-4.2-19.7-5.4-42.9,10.2-58.5c-13.6,19.9-8.2,44.7-6,57.2c7.9-0.4,11.9-9.2,12.4-17.7c-0.8-20.3,1.1-47.1,21.9-62.6 c-16,17.4-20.5,39-18.2,60.4c10.8,0.4,19.7-5.6,21.9-13.8l0.1,0.1c-2.5-17.9-1.3-40.7,14.1-54.2c-10.4,12.5-15.3,38.3-9.7,57 c6,2,13.3-1.5,15.6-6c0.1,0.1,0.2,0.2,0.3,0.2c-2.8-17.9,0.6-39.7,11.2-54.3c-5,11.8-12.2,28.4-8,56c4.1,1,9.6-0.9,12.3-3.3 c0.1,0.2,0.2,0.5,0.3,0.7c-1.6-18.6,1.6-38.7,13.5-53.4c-9.3,17.1-12.4,38-9.3,57.5c5.1,2.6,12.8,2.1,16-2.6 c5.9-17.6,6.6-37.2,2.9-54.9c7.5,16.2,5.3,39-0.1,56.7c3.8,3.2,9.3,4,13.9,2.5c6.5-17.9,6.3-41.1,2.6-54.6 c7.6,14.9,6.5,34.9,2,51.8c0,0,0,0,0.1,0c0.7,4.2,6.6,9.8,10.5,11.4c4.5,1.8,7.7,1.9,12,0.5c4-19.5-0.1-44.5-4.5-51.9 c11.2,13.3,10.9,35.8,8.1,50.6c0.1,0,0.1-0.1,0.2-0.1c0.2,10.2,8.9,18.4,16.5,18.5c7.8-19.3,2.7-43.8-3.3-58.1 c13.1,19.4,13.1,43.5,7.7,58.7c-1.7,10.3,6.5,14.5,10.9,14.9c0.6,0.1,1.1,0.1,1.7,0.1c8-0.2,12.8-8.6,14.2-14.3 c0.1-0.3,0.1-0.6,0.2-0.9c0.3-1.9,0.4-3.7,0.4-5.5c0-0.1,0-0.3,0-0.4c0-1.8-0.1-3.6-0.2-5.3l0,0c-0.9-9.1-4.3-17.7-8.6-25.7 L457,146.7L457,146.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M407.5,99.6c5-2.4,9.7-7.3,9-13c-0.3-2.7-1-4.9-1.9-6.8c-38.4-14.1-83.8-12.7-120.2,7.3c-2.2,2.4-3.7,5.3-3.7,8.9 c0,1.2,0.2,2.3,0.5,3.4C325.2,75.1,373.1,78.7,407.5,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,198.7c-3.6-1.7-5.9-5-7.2-8.9c-11.4,2.9-14.8,18.8-3.3,25.2c-5.8,5.3-2,18.7,4.4,22.8c2-1.1,4.8-0.8,7,0 c2.5,0.9,3.4,3.4,5.4,4.4c4.7,2.2,8.7-7.8,9.1-10.8c0.5-3.9-2.1-9.7-6.3-10.4c6.4-5.5,6-16.3-0.8-21.3 C260.2,200.3,257.3,200.1,254.4,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.9,198.7c-6,5.8-6.9,17.6,4.5,21.3c-3.2,3.1-5.7,8.6-5.2,12.6c0.4,3.1,2.6,8.9,7.3,6.6c2-1,0.7-0.4,3.2-1.4 c2.2-0.8,5-0.7,8.1-0.2c8.2-8,17-28,5.7-34c8.7-5.8,3.1-16.8-9.5-19.3C463.7,190.2,458.9,198.5,450.9,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.8,178.6c-11.5-11.3-12-27.9-23.2-39.6c12.2,3.2,23,10.3,25.7,22.3c2.4-3.2-0.1-15.5-1.6-19.5c-2.2-6-5.3-9-10.7-13 c-6.9-5.1-15.2-7-23.4-9c-4.8-1.1-10.5-2.6-15.9-4.5c10.8,8.6,19.8,19.2,26.4,31.3H457c4.3,8,7.7,16.6,8.6,25.7 c4.5,4.5,12,6.1,17.2,8.2C481.6,180.2,480.7,179.5,479.8,178.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M427.5,113c0.1,0.1,0.2,0.2,0.3,0.2C427.7,113.2,427.6,113.1,427.5,113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M438.7,182L438.7,182C438.7,182.1,438.7,182.1,438.7,182C438.8,182,438.7,181.9,438.7,182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M254.8,193.6c-7.5-5-8.2-16.4-6.4-27.1c-1.3,4.5-2.1,9.1-2.6,13.8c0,3.1,0.4,6.4,1.4,9.4 c1.3,3.9,3.6,7.2,7.2,8.9c2.9,1.4,5.8,1.6,8.4,0.9c2.2-0.6,4.2-1.8,5.7-3.5C264,197.5,258.5,196.1,254.8,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M271.1,190c0.1-0.6,0.1-1.2,0-1.8c1.5,0.4,2.8,0.5,4.1,0.5c-2.2-12.5-7.5-37.3,6-57.2 C265.7,147.1,266.9,170.2,271.1,190z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M430.7,125c6.1,14.3,11.2,38.9,3.3,58.1c1.6,0,3.2-0.3,4.7-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.1,0.6-0.3,1.1-0.3,1.7C443.8,168.5,443.8,144.4,430.7,125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M413.6,166.1c1.1-0.4,2.3-0.8,3.6-1.4c2.8-14.7,3.1-37.3-8.1-50.6C413.6,121.6,417.6,146.6,413.6,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M287.7,171c0.1-0.8,0.1-1.7,0.1-2.5c1.3,0.2,2.5,0.3,3.7,0.3c-2.3-21.4,2.2-43,18.2-60.4 C288.8,123.8,286.8,150.6,287.7,171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M333.7,152.2c0.9,0.9,2,1.4,3.2,1.7c-4.2-27.7,3-44.2,8-56C334.2,112.5,330.9,134.2,333.7,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M313.4,155.1c1.3,1.4,2.8,2.3,4.4,2.8c-5.6-18.8-0.7-44.5,9.7-57C312.1,114.4,311,137.3,313.4,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M369.7,152.7c0.2-0.3,0.3-0.5,0.5-0.8c0.7,1,1.5,1.9,2.3,2.6c5.4-17.7,7.6-40.5,0.1-56.7 C376.4,115.6,375.6,135.1,369.7,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M386.5,157c1.7-0.6,3.3-1.5,4.6-2.8c4.5-16.9,5.6-36.8-2-51.8C392.8,115.9,393,139.1,386.5,157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M349.5,151.3c0.8,1.8,2.4,3.1,4.2,4.1c-3.1-19.5-0.1-40.4,9.3-57.5C351.1,112.5,347.8,132.7,349.5,151.3z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M465.5,172.4L465.5,172.4c-0.3-3.7-1.2-7.4-2.3-10.9c1.7,7.8,1.9,16-0.7,22.6 c-2.3,5.9-8.5,12.5-15.3,14.2c0.7,0.2,1.4,0.4,2,0.4c0.6,0.1,1.1,0.1,1.7,0.1c8-0.2,12.8-8.6,14.2-14.3c0.1-0.3,0.1-0.6,0.2-0.9 c0.3-1.9,0.4-3.7,0.4-5.5c0-0.1,0-0.3,0-0.4C465.8,175.9,465.7,174.2,465.5,172.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.6,164.4c3.3-2.4,5.8-5.7,6.8-9.4l0.1,0.1c-2.3-16.6-1.4-37.5,11-51.2C309.3,119.4,302.6,135.8,306.6,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,196.6c1.5,0.1,3.1-0.1,4.5-0.5c1.5-1.7,2.4-3.8,2.6-6.2c-4.2-19.4-5.3-42.1,9.4-57.7 C262.4,145.7,256.8,171.7,264,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,99.7c-8.6,16.7-11.3,36.9-8.3,55.6c2,1,4.3,1.5,6.6,1.6C358.9,146.1,355.9,113.4,362,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,186.2c3.9-3.3,5.9-9.3,6.3-15.2c-0.8-19.9,1.1-46.1,20.7-61.7C284.5,125.7,275.7,159.4,281.4,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,157c2.5-1.2,4.6-3,5.6-5.1c0.1,0.1,0.2,0.2,0.3,0.2c-2.8-17.6,0.5-38.9,10.6-53.5 C331.9,109.9,322.7,136.3,327.8,157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.1,127.3c11.6,19,11.5,41.8,6.2,56.4c-1,6.3,1.7,10.3,4.9,12.6C452.9,172.9,450.9,146,432.1,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,98.3c7.2,16.2,5.1,38.7-0.3,56.2c1.7,1.4,3.8,2.4,6,2.9C384.2,137.8,386.7,111.5,372.8,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,115.2c10.3,13.4,10,35.1,7.2,49.5c0.1,0,0.1-0.1,0.2-0.1c0.1,6.1,3.3,11.4,7.4,14.8 C429.9,159.3,426.3,127.8,410,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,104.1c6.7,14.7,5.5,33.9,1.2,50.1c0,0,0,0,0.1,0c0.6,3.7,5.2,8.5,9,10.7C403.8,143.7,404.1,119.6,389.9,104.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4E);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4e.50e402bbb1e61cf526e83ddae80f6700.svg";
export { ForwardRef as ReactComponent };